// External Dependencies:
import React from 'react'
import { Link } from 'react-router-dom'

class Slider extends React.Component {
	constructor( props ) {
		super( props )

		this.state = {
			slidesCount: props.slides.length,
			activeSlide: 1,
			autoChange: true
		}
	}

	componentDidMount() {
		this.interval = setInterval( this.timer, 7000 )
	}

	componentWillUnmount() {
		clearInterval( this.interval )
	}

	componentDidUpdate( prevProps, prevState ) {
		// When the props change, reset the slider:
		if ( this.props.slides.length != prevProps.slides.length ) {
			this.setState({
				slidesCount: this.props.slides.length,
				activeSlide: 1,
				autoChange: true
			})
		}
	}

	timer = () => {
		const { autoChange, slidesCount, activeSlide } = this.state

		if ( autoChange ) {
			this.setState({
				activeSlide: activeSlide == slidesCount ? 1 : activeSlide + 1
			})
		}
	}

	selectPrev = () => {
		const { slidesCount, activeSlide } = this.state

		this.setState({
			autoChange: false,
			activeSlide: activeSlide == 1 ? slidesCount : activeSlide - 1
		})
	}

	selectNext = () => {
		const { slidesCount, activeSlide } = this.state

		this.setState({
			autoChange: false,
			activeSlide: activeSlide == slidesCount ? 1 : activeSlide + 1
		})
	}

	render() {
		const { slides } = this.props
		const { activeSlide, showImageModal } = this.state

		if ( slides && slides.length ) {
			let imageSliderMarkup = slides.map( ( slide, i ) => {
				let className = activeSlide == ( i + 1 ) ? 'is-active' : ''

				return (
					<Link key={ slide.image_url } to={ slide.url }>
						<img
							className={ className }
							src={ slide.image_url }
							alt=""
						/>
					</Link>
				)
			})

			let infoMarkup = slides.map( ( slide, i ) => {
				let className = activeSlide == ( i + 1 ) ? 'is-active' : ''

				return (
					<section key={ slide.image_url } className={ className }>
						<Link to={ slide.url }>
							<h3 dangerouslySetInnerHTML={ { __html: slide.title } } />
							<h4 dangerouslySetInnerHTML={ { __html: slide.subtitle } } />

							<div className="-button">
								<span dangerouslySetInnerHTML={ { __html: slide.button_text } } />
								<i className="icon-chevron-right" aria-hidden="true" />
							</div>
						</Link>
					</section>
				)
			})

			return (
				<div className="wide-section wide-slider">
					<div className="image-slider">
						<div className="-inner">
							{ imageSliderMarkup }

							<nav>
								<i className="-back icon-chevron-down" onClick={ this.selectPrev }></i>
								<i className="-forward icon-chevron-down" onClick={ this.selectNext }></i>
							</nav>
						</div>
					</div>

					<div className="-info">
						{ infoMarkup }
					</div>
				</div>
			)
		}

		return null
	}
}

export default Slider



// WEBPACK FOOTER //
// ./components/Slider/Slider.jsx